// extracted by mini-css-extract-plugin
export default {"slide":"PageSlide_slide__+fwia","pageSlideRightToLeft":"PageSlide_pageSlideRightToLeft__AWUHw"};